class LeadStats extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow) {
    super(app, container, listRow, false);
    this.container.empty();
  }

  async render() {
    const self = this;

    this.isRendering = true;

    try {
      this.showLoader({
        "leadsAdded": this.staticPH,
      }, 1);

      let response = await this.app.apis['dashboard'].leadStats();
      let result = response;
      this.isRendering = false;

      this.removeLoader();

      const page = _.template(this.app.templates[this.listRow]);

      result.leadsAdded.leadsAdded = Utils.convertToUsNumberSystem(result.leadsAdded.leadsAdded );
      const $metrics = $(page(result.leadsAdded));
      $metrics.appendTo(this.container);

      this.renderCharts(result);

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  renderCharts(result) {
    this.renderLeadsBySourceChart(result);
    this.renderEmailsQueueChart(result);

    const leadsByStage = result.leadsByStage;
    const leadsByEmailProviders = result.leadsByEmailProviders;

    // Build a map from provider name to its count
    var providerMap = {};
    leadsByStage.series.forEach(function (item) {
      providerMap[item.name] = item.value;
    });

    var dom = document.getElementById('leads-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      grid: {
        top: 0,
        left: '50%',
        right: 0,
        bottom: 0 // Leave room for the bottom legend
      },
      // Global text style applied to all chart components
      textStyle: {
        fontFamily: 'Poppins,sans-serif',
      },
      tooltip: {
        trigger: 'item',
        formatter: '<b>{a}</b> <br/>{b}: {c} <b>({d}%)</b>'
      },

      legend: {
        show : false,
        type: 'scroll', // ✅ Enables scrolling
        orient: 'vertical',
        left: 'left',
        top: 0,
        bottom: 0,
        data: leadsByStage.legend,
        formatter: function (name) {
          var value = providerMap[name] || 0;
          return name + ' (' + value + ')';
        }
      },
      series: [
        {
          name: 'Email Providers',
          avoidLabelOverlap: true,
          type: 'pie',
          selectedMode: 'single',
          radius: [0, '30%'],
          label: {
            position: 'inner',
            fontSize: 12,
            show: false
          },

          labelLine: {
            show: false
          },
          data: leadsByEmailProviders.series
        },
        {
          name: 'Leads Stage', // Series name remains for internal reference, but won't show in labels
          type: 'pie',
          avoidLabelOverlap: true,
          radius: ['45%', '55%'],
          labelLine: {
            show: true,
            length: 20,
            length2: 10
          },
          label: {
            show: true,
            position: 'outside',
            align: 'right',
            // Removed the series name placeholder {a|{a}} and related styles
            padding: [5, 10, 5, 10],
            formatter: '{b|{b}}: {per|{d}%}',
            backgroundColor: '#F6F8FC',
            borderColor: '#8C8D8E',
            borderWidth: 1,
            borderRadius: 4,
            rich: {
              hr: {
                borderColor: '#8C8D8E',
                width: '100%',
                borderWidth: 1,
                height: 0
              },
              b: {
                color: '#4C5058',
                fontSize: 14,
                fontWeight: 'bold',
                lineHeight: 20,
                align: 'right'
              },
              per: {
                color: '#fff',
                backgroundColor: '#4C5058',
                padding: [3, 4],
                borderRadius: 4,
                align: 'right'
              }
            }
          },
          // labelLayout: {
          //   hideOverlap: true
          // },
          // labelLayout: function (params) {
          //   return {
          //     x: 400, // keep X position
          //     y: 30 + params.dataIndex * 28 // stack vertically with spacing (adjust 28 as needed)
          //   };
          // },
          data: leadsByStage.series.map((item, index) => ({
            ...item,
            itemStyle: {color: ['#FF4405', '#E5C103', '#42afe3'][index]}
          }))
        }
      ]
    };


    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }

    window.addEventListener('resize', myChart.resize);
  }

  renderLeadsBySourceChart (result) {
    const leadsBySource = result.leadsBySource['leadsBySource'];

    // Build a map from provider name to its count
    var providerMap = {};
    leadsBySource.series.forEach(function (item) {
      providerMap[item.name] = item.value;
    });

    var dom = document.getElementById('leads-by-source-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      grid: {left: 0, right: 0, top: 0, bottom: 0, containLabel: true},
      textStyle: {
        fontFamily: 'Poppins,sans-serif',
      },
      tooltip: {
        trigger: 'item',
        formatter: '<b>{a}</b> <br/>{b}: {c} <b>({d}%)</b>'
      },
      legend: {
        show : true,
        type: 'scroll', // ✅ Enables scrolling
        orient: 'vertical',
        left: 'left',
        top: 0,
        bottom: 0,
        data: leadsBySource.legend,
        formatter: function (name) {
          var value = providerMap[name] || 0;
          return name + ' (' + value + ')';
        }
      },
      series: [
        {
          name: 'Lead Source',
          type: 'pie',
          // Center the pie chart
          center: ['80%', '50%'],  // Move pie chart to the right
          radius: ['0%', '60%'],

          data: leadsBySource.series,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };


    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }

    window.addEventListener('resize', myChart.resize);
  }

  renderEmailsQueueChart(response) {
    try {
      // Check if the response object is valid
      if (!response || !response.emailsQueue || !response.emailsQueue.data) {
        throw new Error('Invalid response data');
      }

      const emailsQueue = response.emailsQueue;
      const summary = emailsQueue.data['summary'];
      const drilldownData = emailsQueue.data['drilldown'];

      // Ensure 'summary' and 'drilldown' data exist
      if (!summary || !Array.isArray(summary)) {
        throw new Error('Summary data is missing or not in the correct format');
      }

      if (!drilldownData || !Array.isArray(drilldownData)) {
        throw new Error('Drilldown data is missing or not in the correct format');
      }

      var dom = document.getElementById('emails-queue-chart-container');
      if (!dom) {
        throw new Error('Chart container element not found');
      }

      var myChart = echarts.init(dom);

      // Build a map from provider name to its count
      var providerMap = {};
      if (emailsQueue.byStatus && Array.isArray(emailsQueue.byStatus.series)) {
        emailsQueue.byStatus.series.forEach(function (item) {
          providerMap[item.name] = item.value;
        });
      } else {
        throw new Error('byStatus series data is missing or not in the correct format');
      }

      const option = {
        legend: {
          show: true,
          type: 'scroll',
          orient: 'vertical',
          left: 'left',
          top: 0,
          bottom: 0,
          data: emailsQueue.byStatus.legend,
          formatter: function (name) {
            var value = providerMap[name] || 0;
            return name + ' (' + value + ')';
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            center: ['60%', '50%'],
            radius: ['0%', '60%'],
            data: summary,
            universalTransition: {
              enabled: true
            }
          }
        ]
      };

      myChart.setOption(option);

      myChart.on('click', function (event) {
        const groupId = event.data?.groupId;
        if (!groupId) return;

        const drill = drilldownData.find(d => d.dataGroupId === groupId);
        if (!drill) return;

        myChart.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)'
          },
          series: [
            {
              type: 'pie',
              radius: '65%',
              data: drill.data,
              universalTransition: {
                enabled: true
              }
            }
          ],
          graphic: [
            {
              type: 'text',
              right: 10,
              top: 0,
              style: {
                text: '← Back',
                fontSize: 14,
                fontWeight: 'bold',
                cursor: 'pointer'
              },
              onclick: function () {
                myChart.setOption({
                  ...option,
                  graphic: [] // Ensure back button is removed
                }, true); // Force update
              }
            }
          ]
        });
      });

      window.addEventListener('resize', myChart.resize);
    } catch (error) {
      console.error('Error rendering emails queue chart:', error.message);
    }
  }

}

class EmailsSentStats extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow) {
    super(app, container, listRow, false);
    this.container.empty();
  }

  async render() {
    const self = this;

    this.isRendering = true;

    try {
      this.showLoader({
        "emailsSent": this.staticPH,
      }, 1);

      let response = await this.app.apis['dashboard'].emailSentStats();
      let result = response;
      this.isRendering = false;

      this.removeLoader();

      const page = _.template(this.app.templates[this.listRow]);

      result.emailsSent.emailsSent = Utils.convertToUsNumberSystem(result.emailsSent.emailsSent );
      const $metrics = $(page(result.emailsSent));
      $metrics.appendTo(this.container);

      this.renderCharts(result);

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  renderCharts(result) {
    const emailsSentByEmailProviders = result.emailsSentByEmailProviders;

    // Build a map from provider name to its count
    var providerMap = {};
    emailsSentByEmailProviders.series.forEach(function (item) {
      providerMap[item.name] = item.value;
    });

    var dom = document.getElementById('emails-sent-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      grid: {left: 0, right: 0, top: 0, bottom: 0, containLabel: true},
      textStyle: {
        fontFamily: 'Poppins,sans-serif',
      },
      tooltip: {
        trigger: 'item',
        formatter: '<b>{a}</b> <br/>{b}: {c} <b>({d}%)</b>'
      },
      legend: {
        show: false,
        orient: 'horizontal',
        left: 'left',
        bottom: 'bottom',
      },
      series: [
        {
          name: 'Sent to',
          type: 'pie',
          // Center the pie chart
          center: ['50%', '50%'],
          // Adjust the radius so the pie fills the container as much as possible
          radius: ['0%', '60%'],
          data: emailsSentByEmailProviders.series,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };


    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }

    window.addEventListener('resize', myChart.resize);
  }
}

class EmailsEngagementStats extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow) {
    super(app, container, listRow, false);
    this.container.empty();
  }

  async render() {
    const self = this;

    this.isRendering = true;

    try {
      this.showLoader({
        "emailsEngagement": this.staticPH,
      }, 1);

      let response = await this.app.apis['dashboard'].emailEngagementStats();
      let result = response;
      this.isRendering = false;

      this.removeLoader();

      const page = _.template(this.app.templates[this.listRow]);
      result.emailsEngagement.emailsEngagement = Utils.convertToUsNumberSystem(result.emailsEngagement.emailsEngagement );
      const $metrics = $(page(result.emailsEngagement));
      $metrics.appendTo(this.container);

      this.renderCharts(result);

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }

  renderCharts(result) {
    const emailsEngagementByEmailProviders = result.emailsEngagementByEmailProviders;

    // Build a map from provider name to its count
    var providerMap = {};
    emailsEngagementByEmailProviders.series.forEach(function (item) {
      providerMap[item.name] = item.value;
    });

    var dom = document.getElementById('emails-engagement-chart-container');
    var myChart = echarts.init(dom, null, {
      renderer: 'canvas',
      useDirtyRect: false
    });

    var option;

    option = {
      grid: {left: 0, right: 0, top: 0, bottom: 0, containLabel: true},
      tooltip: {
        trigger: 'item'
      },
      legend: {
        show: true,
        orient: 'horizontal',
        center: 'center',
        bottom: 'bottom',
      },
      series: [
        {
          name: 'Email',
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '70%'],
          // adjust the start and end angle
          startAngle: 180,
          endAngle: 360,
          data: emailsEngagementByEmailProviders.series
        }
      ]
    };


    if (option && typeof option === 'object') {
      myChart.setOption(option);
    }


    window.addEventListener('resize', myChart.resize);
  }
}

